export function getColorZone(v) {
    if (v >= 6) return 'green';
    if (v >= 3) return 'yellow';
    return 'red';
}
